import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase, RequestStatus } from '@lib/plugin-redux-core';
import { GET_LLM_PROVIDERS_USE_CASE } from '../../../../../ai';
import { selectLlmProviders, selectLlmProvidersStatus } from '../../../redux/ai-chat/ai-chat.selectors';
export var useLlmProviders = function useLlmProviders() {
  var _ref;

  var dispatch = useDispatch();
  var llmProviders = (_ref = useSelector(selectLlmProviders)) !== null && _ref !== void 0 ? _ref : [];
  var llmProvidersStatus = useSelector(selectLlmProvidersStatus);
  var getLlmProvidersUseCase = getUseCase(GET_LLM_PROVIDERS_USE_CASE, dispatch);
  useEffect(function () {
    getLlmProvidersUseCase.execute({}); // `getUseCase` returns a new object every render, so fetch once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var models = useMemo(function () {
    return llmProviders.flatMap(function (provider) {
      var _provider$models;

      return (_provider$models = provider.models) !== null && _provider$models !== void 0 ? _provider$models : [];
    });
  }, [llmProviders]);
  var defaultModel = useMemo(function () {
    var _models$find;

    return (_models$find = models.find(function (model) {
      return model.isDefault;
    })) !== null && _models$find !== void 0 ? _models$find : models[0];
  }, [models]);
  return {
    llmProviders: llmProviders,
    models: models,
    defaultModel: defaultModel,
    isLoading: llmProvidersStatus === RequestStatus.EXECUTE,
    isError: llmProvidersStatus === RequestStatus.ERROR
  };
};